import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import Aura from '@primeng/themes/aura';
import { AppUpdateService } from '@services/app-update/app-update.service';
import { readBuildInfo, translationFileSuffix } from '@services/app-update/build-info';
import { BearertokenInterceptor } from '@services/httpinterceptor/bearertoken.interceptor';
import { LocaleInterceptor } from '@services/httpinterceptor/locale.interceptor';
import { provideQueryClient, QueryClient } from '@tanstack/angular-query-experimental';
import { providePrimeNG } from 'primeng/config';
import { DOCUMENT } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  NavigationError,
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withNavigationErrorHandler
} from '@angular/router';
import { appRoutes } from './app.routes';

// Required for AOT compilation
export function HttpLoaderFactory(http: HttpClient, document: Document): TranslateHttpLoader {
  // A build-azonosító a címben: új build után nem jöhet gyorsítótárból régi fordítás
  return new TranslateHttpLoader(http, './assets/i18n/', translationFileSuffix(readBuildInfo(document)));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      withEnabledBlockingInitialNavigation(),
      // Hiányzó oldalkód (egy új telepítés törölte a régi fájlt): egyszeri teljes újratöltés
      withNavigationErrorHandler((error: NavigationError) => inject(AppUpdateService).handleNavigationError(error))
    ),
    // Új verzió figyelése; build-azonosító nélkül (fejlesztői szerver) nem indul el
    provideAppInitializer(() => inject(AppUpdateService).start()),
    provideHttpClient(withFetch()),
    { provide: HTTP_INTERCEPTORS, useClass: BearertokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LocaleInterceptor, multi: true },
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
    provideQueryClient(new QueryClient()),
    importProvidersFrom(HttpClientModule), // Required for TranslateHttpLoader
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient, DOCUMENT]
        }
      })
    )
  ]
};
